(() => {
  const root = document.getElementById('form-co-create');
  const form = root?.querySelector('#RayArtCustomDesignInquiry');
  if (!root || !form) return;
  const enhancement = root.querySelector('.rfc-enhancement');
  const native = root.querySelector('.rfc-native-form');
  const department = form.querySelector('#RFInquiryDepartment');
  const concept = root.querySelector('#rfc-concept');
  document.querySelectorAll('[data-rfl-title]').forEach(card => {
    if (![...concept.options].some(option => option.value === card.dataset.rflTitle)) {
      const option = document.createElement('option');
      option.value = card.dataset.rflTitle; option.textContent = card.dataset.rflTitle;
      option.dataset.image = card.dataset.rflImage; concept.append(option);
    }
  });
  const hidden = document.createElement('input');
  hidden.type = 'hidden'; hidden.name = 'contact[Creative brief]'; hidden.disabled = true;
  form.append(hidden);
  const state = {space:'',style:'',materials:'',purpose:'',concept:''};
  const radios = [...root.querySelectorAll('[name="rfc_space"]')];
  const syncSummary = () => {
    const lines = [root.dataset.briefHeading];
    Object.keys(state).forEach(key => {
      const item = root.querySelector('[data-rfc-summary="' + key + '"]');
      item.textContent = state[key] || root.dataset.openLabel;
      lines.push(item.previousElementSibling.textContent + ': ' + (state[key] || root.dataset.openLabel));
    });
    hidden.value = lines.join('\n');
    hidden.disabled = !Object.values(state).some(Boolean);
  };
  const show = (step, focus = true) => {
    root.querySelectorAll('[data-rfc-panel]').forEach(panel => {panel.hidden = Number(panel.dataset.rfcPanel) !== step;});
    root.querySelectorAll('.rfc-steps button').forEach(button => {
      if (Number(button.dataset.rfcStep) === step) button.setAttribute('aria-current','step'); else button.removeAttribute('aria-current');
    });
    native.hidden = step !== 3;
    root.dataset.step = String(step);
    syncSummary();
    if (focus) root.querySelector('[data-rfc-panel="'+step+'"] h3').focus();
  };
  const syncDepartment = () => {
    const match = radios.find(radio => radio.dataset.formDepartment === department.value);
    radios.forEach(radio => {radio.checked = radio === match;});
    state.space = match ? match.value : department.value;
    syncSummary();
  };
  const syncConcept = () => {
    state.concept = concept.value;
    const option = concept.selectedOptions[0];
    const peek = root.querySelector('.rfc-concept-peek');
    peek.hidden = !option?.dataset.image;
    if (!peek.hidden) peek.querySelector('img').src = option.dataset.image;
    syncSummary();
  };
  root.querySelectorAll('[data-rfc-step]').forEach(button => button.addEventListener('click', () => show(Number(button.dataset.rfcStep))));
  radios.forEach(radio => radio.addEventListener('change', () => {
    if (!radio.checked) return;
    state.space = radio.value;
    department.value = radio.dataset.formDepartment;
    department.dispatchEvent(new Event('change',{bubbles:true}));
    syncSummary();
  }));
  root.querySelectorAll('[data-rfc-field]').forEach(select => select.addEventListener('change', () => {
    state[select.dataset.rfcField] = select.value;
    if (select === concept) syncConcept(); else syncSummary();
  }));
  department.addEventListener('change', syncDepartment);
  document.querySelectorAll('a[href="#form-contact"]').forEach(link => link.addEventListener('click', () => {
    syncDepartment();
    if (link.dataset.concept) {
      const match = [...concept.options].find(option => option.value === link.dataset.concept);
      if (match) {concept.value = match.value; syncConcept();}
    }
    show(3, false);
  }));
  document.querySelectorAll('a[href="#form-co-create"]').forEach(link => link.addEventListener('click', () => show(1)));
  const hashStep = () => {if (location.hash === '#form-co-create') show(1,false); else if (location.hash === '#form-contact' || location.hash === '#RayArtCustomDesignInquiry') show(3,false);};
  form.addEventListener('invalid', () => show(3,false), true);
  form.addEventListener('submit', syncSummary);
  enhancement.hidden = false;
  syncDepartment();
  show(form.querySelector('.rf-inquiry-message,.rf-inquiry-errors') ? 3 : 1,false);
  hashStep();
  window.addEventListener('hashchange',hashStep);
})();

